/**
 * A server timestamp rendered in the viewer's resolved zone WITH the zone's
 * short name ("Oct 7, 17:54:20 EDT"); hovering or focusing shows the UTC
 * time and the full zone id, so two people in different zones can agree on
 * which moment it was (#128).
 *
 * Renders a semantic <time> whose dateTime is the ISO-8601 UTC instant.
 */
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useTimePreference } from './useTimezone';
import { formatDateTz, formatUtc } from './formatDate';
import { parseServerTs } from './parseServerTs';

export default function ZonedTime({ value, fallback = '—', style = 'long', withSeconds = true }) {
  const { tz } = useTimePreference(); // re-render on zone / locale / 12h change
  const ms = parseServerTs(value);
  if (value == null || value === '' || !Number.isFinite(ms)) return <span>{fallback}</span>;
  const text = formatDateTz(value, { style, withSeconds });
  const utc = formatUtc(value);
  const title = `${utc} · shown in ${tz}`;
  return (
    <Tooltip title={title} arrow describeChild>
      <time dateTime={new Date(ms).toISOString()} tabIndex={0}>
        {text}
      </time>
    </Tooltip>
  );
}
